"use client";

import { useState } from 'react';

export default function OilGasDashboardsSection() {
  const [activeTab, setActiveTab] = useState(0);

  const dashboards = [
    {
      title: 'CEO / CFO ENERGY DASHBOARD',
      subtitle: 'Executive Production & Financial Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Energy Executive Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Asset Utilization', value: '76%', color: '#C5A572' },
            { x: 186, label: 'Cost per Barrel', value: '₹4,280', color: '#1B2845' },
            { x: 356, label: 'Daily Production', value: '21.4K bbl', color: '#16a34a' },
            { x: 526, label: 'Operating Margin', value: '34.2%', color: '#16a34a' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
            </g>
          ))}

          {/* Production Output by Asset */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Production Output by Asset (bbl/day)</text>
          {[
            { asset: 'Field Alpha', val: 7200, color: '#1B2845' },
            { asset: 'Field Beta', val: 5800, color: '#C5A572' },
            { asset: 'Offshore Rig 1', val: 4600, color: '#3b82f6' },
            { asset: 'Offshore Rig 2', val: 3800, color: '#8b5cf6' },
          ].map((a, i) => (
            <g key={i}>
              <text x="28" y={172 + i * 30} fill="#374151" fontSize="9" fontFamily="sans-serif">{a.asset}</text>
              <rect x="120" y={160 + i * 30} width={a.val / 40} height="16" fill={a.color} rx="2" opacity="0.8" />
              <text x={126 + a.val / 40} y={172 + i * 30} fill="#374151" fontSize="9" fontFamily="sans-serif">{a.val.toLocaleString()}</text>
            </g>
          ))}

          {/* Cost per Barrel Trend */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Cost per Barrel Trend (₹)</text>
          <polyline points="380,285 420,278 460,282 500,268 540,272 580,258 620,252 660,242" fill="none" stroke="#C5A572" strokeWidth="2.5" strokeLinecap="round" />
          <polyline points="380,285 420,278 460,282 500,268 540,272 580,258 620,252 660,242 660,295 380,295 Z" fill="#C5A572" opacity="0.08" />
          {[380,420,460,500,540,580,620,660].map((x, i) => (
            <circle key={i} cx={x} cy={[285,278,282,268,272,258,252,242][i]} r="3" fill="#1B2845" />
          ))}
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug'].map((m, i) => (
            <text key={i} x={380 + i * 40 - 6} y="308" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}

          {/* Operating Margin by Facility */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Operating Margin by Facility</text>
          {[
            { facility: 'Field Alpha', margin: '42%', color: '#16a34a' },
            { facility: 'Field Beta', margin: '36%', color: '#65a30d' },
            { facility: 'Offshore Rig 1', margin: '28%', color: '#ca8a04' },
            { facility: 'Offshore Rig 2', margin: '22%', color: '#ea580c' },
          ].map((f, i) => (
            <g key={i}>
              <text x={28 + i * 168} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{f.facility}</text>
              <rect x={28 + i * 168} y="364" width="140" height="12" fill="#f3f4f6" rx="3" />
              <rect x={28 + i * 168} y="364" width={parseInt(f.margin) * 2.8} height="12" fill={f.color} rx="3" opacity="0.8" />
              <text x={28 + i * 168} y="392" fill={f.color} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{f.margin} margin</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'OPERATIONS / FIELD MANAGEMENT DASHBOARD',
      subtitle: 'Well Performance & Maintenance Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Field Operations Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Rig Uptime', value: '91%', color: '#16a34a' },
            { x: 186, label: 'Active Wells', value: '18 / 22', color: '#1B2845' },
            { x: 356, label: 'Production Variance', value: '-2.4%', color: '#ca8a04' },
            { x: 526, label: 'Maintenance Due', value: '3 assets', color: '#dc2626' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="20" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
            </g>
          ))}

          {/* Well Performance Grid */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Well Performance Status</text>
          {[
            ['W-01','1,820 bbl','#16a34a'],['W-02','1,640 bbl','#16a34a'],['W-03','1,580 bbl','#65a30d'],
            ['W-04','1,420 bbl','#ca8a04'],['W-05','1,280 bbl','#ea580c'],['W-06','OFFLINE','#dc2626'],
          ].map(([well, output, color], i) => (
            <g key={i}>
              <rect x={28 + (i % 3) * 100} y={160 + Math.floor(i / 3) * 60} width="90" height="48" fill="#f9fafb" rx="6" stroke="#e5e7eb" strokeWidth="1" />
              <text x={28 + (i % 3) * 100 + 8} y={178 + Math.floor(i / 3) * 60} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{well}</text>
              <text x={28 + (i % 3) * 100 + 8} y={192 + Math.floor(i / 3) * 60} fill={color as string} fontSize="8" fontFamily="sans-serif">{output}</text>
              <circle cx={28 + (i % 3) * 100 + 78} cy={168 + Math.floor(i / 3) * 60} r="5" fill={color as string} opacity="0.8" />
            </g>
          ))}

          {/* Equipment Failure Predictions */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Equipment Failure Prediction Scores</text>
          {[
            { equip: 'Pump P-12 (Rig 2)', score: 87, color: '#dc2626', bg: '#fef2f2' },
            { equip: 'Compressor C-4', score: 72, color: '#ea580c', bg: '#fff7ed' },
            { equip: 'Separator S-8', score: 58, color: '#ca8a04', bg: '#fefce8' },
            { equip: 'Valve V-21', score: 34, color: '#65a30d', bg: '#f0fdf4' },
          ].map((e, i) => (
            <g key={i}>
              <rect x="370" y={158 + i * 36} width="302" height="28" fill={e.bg} rx="5" />
              <text x="382" y={170 + i * 36} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{e.equip}</text>
              <text x="382" y={182 + i * 36} fill={e.color} fontSize="9" fontFamily="sans-serif">Failure risk: {e.score}%</text>
              <rect x="560" y={162 + i * 36} width="100" height="10" fill="#f3f4f6" rx="3" />
              <rect x="560" y={162 + i * 36} width={e.score} height="10" fill={e.color} rx="3" opacity="0.7" />
            </g>
          ))}

          {/* Maintenance Schedule */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Upcoming Maintenance Schedule</text>
          {[
            { asset: 'Pump P-12', date: 'Mar 16', type: 'Bearing replacement', status: 'URGENT', color: '#dc2626' },
            { asset: 'Compressor C-4', date: 'Mar 22', type: 'Oil & filter change', status: 'SCHEDULED', color: '#ca8a04' },
            { asset: 'Separator S-8', date: 'Apr 5', type: 'Routine inspection', status: 'PLANNED', color: '#16a34a' },
          ].map((m, i) => (
            <g key={i}>
              <text x={28 + i * 224} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{m.asset}</text>
              <text x={28 + i * 224} y="372" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{m.date} — {m.type}</text>
              <rect x={28 + i * 224} y="378" width="60" height="16" fill={m.color} rx="3" opacity="0.15" />
              <text x={28 + i * 224 + 4} y="390" fill={m.color} fontSize="8" fontWeight="bold" fontFamily="sans-serif">{m.status}</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'SAFETY & COMPLIANCE DASHBOARD',
      subtitle: 'Safety Incidents & Regulatory Readiness',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Safety & Compliance Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Days Without Incident', value: '142', color: '#16a34a' },
            { x: 186, label: 'Open Safety Issues', value: '7', color: '#ca8a04' },
            { x: 356, label: 'Compliance Score', value: '94.2%', color: '#16a34a' },
            { x: 526, label: 'Audit Readiness', value: '88%', color: '#C5A572' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="20" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
            </g>
          ))}

          {/* Safety Incidents Donut */}
          <rect x="16" y="128" width="220" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Incidents by Severity</text>
          <circle cx="116" cy="220" r="52" fill="none" stroke="#f3f4f6" strokeWidth="20" />
          <circle cx="116" cy="220" r="52" fill="none" stroke="#16a34a" strokeWidth="20" strokeDasharray="196 327" strokeDashoffset="0" />
          <circle cx="116" cy="220" r="52" fill="none" stroke="#ca8a04" strokeWidth="20" strokeDasharray="98 327" strokeDashoffset="-196" />
          <circle cx="116" cy="220" r="52" fill="none" stroke="#dc2626" strokeWidth="20" strokeDasharray="33 327" strokeDashoffset="-294" />
          <text x="116" y="216" textAnchor="middle" fill="#1B2845" fontSize="16" fontWeight="bold" fontFamily="sans-serif">24</text>
          <text x="116" y="230" textAnchor="middle" fill="#6b7280" fontSize="8" fontFamily="sans-serif">Total YTD</text>
          <rect x="28" y="285" width="10" height="10" fill="#16a34a" rx="2" />
          <text x="42" y="294" fill="#374151" fontSize="8" fontFamily="sans-serif">Low (60%)</text>
          <rect x="90" y="285" width="10" height="10" fill="#ca8a04" rx="2" />
          <text x="104" y="294" fill="#374151" fontSize="8" fontFamily="sans-serif">Med (30%)</text>
          <rect x="158" y="285" width="10" height="10" fill="#dc2626" rx="2" />
          <text x="172" y="294" fill="#374151" fontSize="8" fontFamily="sans-serif">High (10%)</text>

          {/* Environmental Compliance */}
          <rect x="248" y="128" width="220" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="260" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Environmental Compliance</text>
          {[
            { metric: 'CO₂ Emissions', val: 88, limit: 100, color: '#16a34a' },
            { metric: 'Water Usage', val: 72, limit: 100, color: '#65a30d' },
            { metric: 'Flaring Rate', val: 45, limit: 100, color: '#ca8a04' },
            { metric: 'Spill Incidents', val: 12, limit: 100, color: '#16a34a' },
          ].map((e, i) => (
            <g key={i}>
              <text x="260" y={170 + i * 32} fill="#374151" fontSize="9" fontFamily="sans-serif">{e.metric}</text>
              <rect x="260" y={174 + i * 32} width="190" height="12" fill="#f3f4f6" rx="3" />
              <rect x="260" y={174 + i * 32} width={e.val * 1.9} height="12" fill={e.color} rx="3" opacity="0.75" />
              <text x="456" y={184 + i * 32} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{e.val}%</text>
            </g>
          ))}

          {/* Regulatory Readiness Checklist */}
          <rect x="480" y="128" width="204" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="492" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Regulatory Readiness</text>
          {[
            { item: 'OISD Standards', status: '✓', color: '#16a34a' },
            { item: 'PNGRB Compliance', status: '✓', color: '#16a34a' },
            { item: 'Environmental NOC', status: '✓', color: '#16a34a' },
            { item: 'Safety Audit Report', status: '⚠', color: '#ca8a04' },
            { item: 'Emergency Response Plan', status: '✓', color: '#16a34a' },
            { item: 'Worker Safety Certs', status: '✗', color: '#dc2626' },
          ].map((r, i) => (
            <g key={i}>
              <text x="492" y={168 + i * 22} fill="#374151" fontSize="9" fontFamily="sans-serif">{r.item}</text>
              <text x="660" y={168 + i * 22} fill={r.color} fontSize="11" fontWeight="bold" fontFamily="sans-serif" textAnchor="middle">{r.status}</text>
            </g>
          ))}

          {/* Safety Risk Heatmap */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Safety Risk Heatmap by Site</text>
          {[
            { site: 'Field Alpha', risk: 'LOW', color: '#16a34a', bg: '#f0fdf4' },
            { site: 'Field Beta', risk: 'LOW', color: '#16a34a', bg: '#f0fdf4' },
            { site: 'Offshore Rig 1', risk: 'MEDIUM', color: '#ca8a04', bg: '#fefce8' },
            { site: 'Offshore Rig 2', risk: 'HIGH', color: '#dc2626', bg: '#fef2f2' },
          ].map((s, i) => (
            <g key={i}>
              <rect x={28 + i * 168} y="348" width="150" height="50" fill={s.bg} rx="6" />
              <text x={28 + i * 168 + 10} y="368" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{s.site}</text>
              <text x={28 + i * 168 + 10} y="384" fill={s.color} fontSize="10" fontWeight="bold" fontFamily="sans-serif">{s.risk} RISK</text>
            </g>
          ))}
        </svg>
      ),
    },
  ];

  return (
    <section className="py-24 bg-cream px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-4">
            Role-Specific Intelligence for <span className="italic">Energy Leaders</span>
          </h2>
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">
            Purpose-built dashboards for every decision-maker in your energy organization.
          </p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {dashboards.map((d, i) => (
            <button
              key={i}
              onClick={() => setActiveTab(i)}
              className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 ${
                activeTab === i
                  ? 'bg-navy text-white shadow-md'
                  : 'bg-white text-navy border border-gray-200 hover:border-gold/40'
              }`}
            >
              {d.title}
            </button>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-sm">
          <div className="mb-4">
            <h3 className="font-serif text-navy text-xl font-bold">{dashboards[activeTab].title}</h3>
            <p className="text-charcoal/60 text-sm mt-1">{dashboards[activeTab].subtitle}</p>
          </div>
          <div className="w-full aspect-[700/420] rounded-xl overflow-hidden border border-gray-100">
            {dashboards[activeTab].svg}
          </div>
          <div className="flex gap-4 mt-6">
            <button className="bg-navy hover:bg-navy/90 text-white text-sm font-semibold px-6 py-2.5 rounded-lg transition-all duration-200">
              View Demo
            </button>
            <button className="border border-navy text-navy hover:bg-navy/5 text-sm font-semibold px-6 py-2.5 rounded-lg transition-all duration-200">
              Request Customization
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
